var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"participants-view"},[(_vm.dataHelper)?_c('participants-table',{attrs:{"data-helper":_vm.dataHelper,"user-id":_vm.userId,"fields":_vm.fields}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }